import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicTag } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const fetchRecordingTags = async ({
  organisationId,
}: {
  organisationId: string;
}): Promise<PublicTag[]> => {
  const response = await axiosClient.get(`${organisationId}/recording-tags`);
  return response.data;
};

export function fetchRecordingTagsKey({
  organisationId,
}: {
  organisationId: string;
}) {
  return ["recording-tags", organisationId];
}

export function useFetchRecordingTags(
  { organisationId }: { organisationId: string },
  queryOptions?: Partial<UseQueryOptions<PublicTag[], HttpError>>,
) {
  return useQuery({
    queryKey: fetchRecordingTagsKey({ organisationId }),
    queryFn: () =>
      fetchRecordingTags({
        organisationId,
      }),
    ...queryOptions,
  });
}
